import { render, staticRenderFns } from "./SidebarSecition.vue?vue&type=template&id=3cde386e&scoped=true&"
import script from "./SidebarSecition.vue?vue&type=script&lang=js&"
export * from "./SidebarSecition.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSecition.vue?vue&type=style&index=0&id=3cde386e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cde386e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol})
